type NaverProductItem = {
  id: string; // 상품 id (필수).
  name: string; // string 상품 명 (필수)
  category: string; // string 카테고리 ex) "화장품/스킨케어/크림"
  quantity: number; // number 결제 수량 (필수)
  payAmount: number; // number 결제 금액 (필수), 1개당 3만원, 3개 9만원
  option: string; // string 상품 자체의 옵션 (예: 색상 )
};

interface PurchaseEvent {
  id: string; // 구매 id
  items: NaverProductItem[]; // 구매한 상품 리스트
  value: number; // items 총 합산 금액
}
// 함수 공통화 처리가 필요합니다
export const wcsPurchaseEvent = ({ id, items, value }: PurchaseEvent) => {
  if (!window.wcs) return;
  const result = {
    type: 'purchase',
    id,
    items, //
    value,
  };
  if (window.wcs) {
    window.wcs.trans(result); // wcs 가 window 객체나 또는 어디에 위치해 있는지 확인 필요.
  }
};

// 구매 완료 시 아이템을 구성합니다(예시)
// const purchaseResult = {
//   id: '123456789', // 구매 id (필수): 주문번호 id
//   // items 배열에 각 구매한 아이템들을 담아줍니다. 아이템 옵션들의 값은 전부 필수로 채어넣어주세요
//   items: [
//     {
//       // #1번 item
//       id: '7786', //string 상품 id (필수)
//       name: 'A낚시로드', //string 상품 명 (필수)
//       category: '낚시용품/로드/광어다운샷 로드', //string 카테고리 (필수값은 아니지만 꼭 넣어주세요)
//       quantity: 3, //number 결제 수량 (필수)
//       payAmount: 150000, //number 결제 금액 (필수), 1개당 5만원, 3개 15만원
//       option: '용량:120', //string 상품 자체의 옵션 (예: 색상 / 필수값은 아니지만 넣어주세요)
//     },
//     {
//       // #2번 item
//       id: '8123', //string 상품 id (필수)
//       name: '윤조에센스', //string 상품 명 (필수)
//       category: '패션/의류/TOP', //string 카테고리 (필수값은 아니지만 꼭 넣어주세요)
//       quantity: 2, //number 결제 수량 (필수)
//       payAmount: 200000, //number 결제 금액 (필수), 1개는 10만원, 2개 20만원
//       option: '용량:120', //string 상품 자체의 옵션 (예: 색상 / 필수값은 아니지만 넣어주세요)
//     },
//   ],
//   value: 353000, // 총 결제 금액 (필수: 배송비 포함), 15만 + 20만 + 3천원(배송비) = 353000원
// };
